// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__S4sV6","tabsBox":"styles_tabsBox__3TA-3","createButton":"styles_createButton__24LXq"};